import cloneDeep from 'lodash-es/cloneDeep';
import { createReducer, on } from '@ngrx/store';
import { DialogState } from './dialog.model';
import {
  vshcDialogOpen,
  vshcDialogClose,
  vshcDialogToggle,
  DialogActionUnion
} from './dialog.action';
import { arrayify, zefResetState } from '../core';

export const initialState = new DialogState();

const actionReducer = createReducer(
  initialState,
  on(
    vshcDialogOpen,
    (s, { key, meta }): DialogState => ({
      ...s,
      keys: {
        ...s.keys,
        [key]: { state: true, meta }
      }
    })
  ),
  on(
    vshcDialogClose,
    (s, { key }): DialogState => {
      const keys = arrayify<string>(key);
      const bag = cloneDeep(s.keys);

      keys.forEach((k) => {
        const bagItm = bag[k];

        if (bagItm) {
          bag[k].state = false;
          bag[k].meta = undefined;
        }
      });

      return {
        ...s,
        keys: {
          ...bag
        }
      };

    }
  ),
  on(
    vshcDialogToggle,
    (s, { key, meta }): DialogState => ({
      ...s,
      keys: {
        ...s.keys,
        [key]: s.keys[key]
          ?
            {
              state: !s.keys[key].state,
              meta
            }
          : {
            state: true,
            meta
          }
      }
    })
  ),
  on(zefResetState, () => initialState)
);

export function dialogReducer(
  state = initialState,
  action: DialogActionUnion
) {
  return actionReducer(state, action);
}
